import { KeyValueStorage } from 'record-it-utils/dataStorage/KeyValueStorage';

export class StoreUtils {
  private constructor() {}

  public static async saveState(storeName: string, state: any): Promise<void> {
    await KeyValueStorage.setItem(
      this.getStorageKeyForStoreName(storeName),
      state
    );
  }

  public static async loadState<T>(storeName: string): Promise<T | undefined> {
    return KeyValueStorage.getItem(this.getStorageKeyForStoreName(storeName));
  }

  public static getStorageKeyForStoreName(name: string): string {
    return `store.${name}`;
  }
}
